import React from "react";
var __jsx = React.createElement;
import stl from "./StepsContainer.module.css";
import SingleStep from './SingleStep';
import { useTranslation } from "@i18n";
var StepsContainer = function StepsContainer(_ref) {
  var steps = _ref.steps,
    percentage = _ref.percentage,
    _ref$titleContainerCl = _ref.titleContainerClassname,
    titleContainerClassname = _ref$titleContainerCl === void 0 ? "" : _ref$titleContainerCl;
  var _useTranslation = useTranslation(["web_sell_trade"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.titleContainer, "!justify-evenly"].join(" ")
  }, steps === null || steps === void 0 ? void 0 : steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(SingleStep, {
      key: index,
      title: t(step.stepName, {
        ns: "web_sell_trade"
      }),
      pointNumber: step.stepNumber,
      active: step.active,
      done: step.done
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.progressBarContainer
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "".concat(percentage, "%")
    }
  })));
};
export default StepsContainer;